import angular from 'angular';
import {Service, Module} from 'app/decorators';
import confirmTpl from './confirm.modal.html';


class ConfirmModalCtrl {
    constructor ($sce, $uibModalInstance, context, wait) {
        "ngInject";
        this.$modal = $uibModalInstance;
        this.wait = wait;

        this.confirmName = 'Submit';
        this.confirmClass = 'btn-submit';

        this.cancelName = 'Cancel';
        this.cancelClass = 'btn-default';

        this.title = 'Confirm';
        this.text = "Are you sure ?";

        angular.extend(this, context);

        this.title = $sce.trustAsHtml(this.title);
        this.text = $sce.trustAsHtml(this.text);

        this.loading = false;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        self.loading = true;
        self.wait.resolve({
            choice: true,
            close: function(){
                self.loading = false;
                self.$modal.close();
            },
        });
    }
}

@Module({
    name: 'app.services.modals',
})
@Service('Modal')
export default class Modal {
    constructor ($q, $uibModal) {
        "ngInject";
        this.$q = $q;
        this.$uibModal = $uibModal;
    }

    open ({as = 'vm', backdrop = 'static', ...params}) {
        params['controllerAs'] = as;
        params['backdrop'] = backdrop;
        return this.$uibModal.open(params);
    }

    openConfirm(context) {
        context = context || {};
        let deffered = this.$q.defer();
        let $modal = this.open({
            template: confirmTpl,
            controller: ConfirmModalCtrl,
            size: 'medium',
            resolve: {
                context: () => context,
                wait: () => deffered,
            },
        });
        $modal.wait = deffered.promise;
        return $modal;
    }

    openConfirmDelete(context) {
        context = context || {};
        var ctx = {
            confirmName: 'Delete',
            confirmClass: 'btn-delete',
        };
        angular.extend(ctx, context);
        return this.openConfirm(ctx);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/modals.js